module.exports = __webpack_public_path__ + "img/Netherlands.cfff225e.png";